import { YofiScoreZodSchema } from "@redotech/redo-return-core-common/return";
import * as z from "zod";

/**
 * Schema for the getCustomerYofiScores RPC endpoint
 */
export const getCustomerYofiScores = {
  name: "getCustomerYofiScores" as const,
  input: z.object({ shopifyCustomerId: z.string() }),
  output: z.record(z.string(), YofiScoreZodSchema).nullable(),
};
